import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { mmtc_buy_responseApi } from "../../app/slices/mmtc/mmtc_buy_responseSlice";

import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { toast } from "react-toastify";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { Loader } from "lucide-react";
import useFilterHandler from "../../components/filterhandler";
import Loader1 from "../digitalGold/Loader";
import Filter from "../../components/Filter";
import { Button } from "@mui/material";

export default function Mmtc_buy_response() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  // useEffect(() => {
  //   dispatch(mmtc_buy_responseApi(queryParams));
  // }, [dispatch, queryParams]);

  const [filterData, setFilterData] = useState({
    name: "",
    transactionId: "",
    metal: "",
    invoiceId: "",
    customerRefNo: "",
    mmtcRefNo: "",
    metalType: "",
    startDate: "",
    endDate: "",
  });

  const url = `/api/admin/mmtc-buy-res/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);
  console.log(results, "nautiyal>>>>>>>>>>>>>>>>>>");
  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //   else {
    //    // toast.success(message);
    //  }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.mmtc_buy_response.mmtc_buy_response.data,
  );
  const stateLoading = useSelector((state) => state.mmtc_buy_response.loading);
  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id || "N/A");
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id || "N/A"}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),

    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("customerName", {
      header: "Name",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.customerName || "N/A",
    }),

    columnHelper.accessor("phone", {
      header: "Phone",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.phone || "N/A",
    }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.partner_username || "Batuk",
    }),
    columnHelper.accessor("subpartner_username", {
      header: "Sub Partner",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.subpartner_username || "-",
    }),
    columnHelper.accessor("mmtcRefNo", {
      header: "MMTC Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.mmtcRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.mmtcRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.mmtcRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("type", {
    //   header: "Type",
    //   size: 30,
    // }),
    // columnHelper.accessor("calculationType", {
    //   header: "Calculation Type",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.calculationType || "N/A",
    // }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),

    columnHelper.accessor("rate", {
      header: "Metal Rate",
      size: 30,
    }),

    columnHelper.accessor("calculationType", {
      header: "Calculation Type",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.calculationType,
    }),
    // columnHelper.accessor("taxType", {
    //   header: "Tax Type",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.taxType || "N/A",
    // }),
    // columnHelper.accessor("tax1Amt", {
    //   header: "Tax 1 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax2Amt", {
    //   header: "Tax 2 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax3Amt", {
    //   header: "Tax 3 Amount",
    //   size: 30,
    // }),
    columnHelper.accessor("preTaxAmount", {
      header: "Pre Tax Amount",
      size: 30,
    }),
    columnHelper.accessor("totalTaxAmount", {
      header: "Total Tax Amount",
      size: 30,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),
    // columnHelper.accessor("metalRate", {
    //   header: "Metal Rate",
    //   size: 30,
    // }),
    // columnHelper.accessor("pricePerG", {
    //   header: "Price per Gram",
    //   size: 30,
    // }),
    // columnHelper.accessor("orderId", {
    //   header: "Order ID",
    //   size: 50,
    // }),
    columnHelper.accessor("order_id", {
      header: "Order ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.order_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.order_id}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.order_id}
            </>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("transactionId", {
    //   header: "Transaction ID",
    //   size: 50,
    // }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("invoiceId", {
      header: "Invoice ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoiceId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.invoiceId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.invoiceId}
            </>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("transactionDate", {
    //   header: "Transaction Date",
    //   size: 50,
    //   Cell: ({ cell }) =>
    //     cell.row.original.transactionDate
    //       ? cell.row.original.transactionDate.split("T")[0]
    //       : "N/A",
    // }),
    // columnHelper.accessor("executionDateTime", {
    //   header: "Execution Date",
    //   size: 50,
    //   Cell: ({ cell }) =>
    //     cell.row.original.executionDateTime
    //       ? cell.row.original.executionDateTime?.split("T")[0]
    //       : "N/A",
    // }),

    // columnHelper.accessor("netAmount", {
    //   header: "Net Amount",
    //   size: 50,
    // }),
    // columnHelper.accessor("currencyPair", {
    //   header: "Currency Pair",
    //   size: 50,
    // }),
    // columnHelper.accessor("value", {
    //   header: "Value",
    //   size: 50,
    // }),
    // columnHelper.accessor("paymentid", {
    //   header: "Payment ID",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.paymentid || "N/A",
    // }),

    // columnHelper.accessor("paymentid", {
    //   header: "Payment ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.paymentid);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.paymentid}>
    //         <>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.paymentid}
    //         </>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.status || "N/A",
    // }),
    // columnHelper.accessor("invoicePDF", {
    //   header: "Invoice PDF",
    //   size: 50,
    //   Cell: ({ cell }) =>
    //     cell.row.original?.invoicePDF ? (
    //       <a href={cell.row.original.invoicePDF} target="_blank" rel="noopener noreferrer">
    //         View Invoice
    //       </a>
    //     ) : (
    //       "N/A"
    //     ),
    // }),
    // columnHelper.accessor("payOutAccountNumber", {
    //   header: "Payout Account Number",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.payOutAccountNumber || "N/A",
    // }),
    // columnHelper.accessor("billingAddressId", {
    //   header: "Billing Address ID",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.billingAddressId || "N/A",
    // }),
    // columnHelper.accessor("invoiceId", {
    //   header: "Invoice ID",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.invoiceId || "N/A",
    // }),
    // columnHelper.accessor("addressLine1", {
    //   header: "Address Line 1",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.addressLine1 || "N/A",
    // }),
    // columnHelper.accessor("addressLine2", {
    //   header: "Address Line 2",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.addressLine2 || "N/A",
    // }),
    // columnHelper.accessor("city", {
    //   header: "City",
    //   size: 50,
    // }),
    // columnHelper.accessor("state", {
    //   header: "State",
    //   size: 50,
    // }),
    // columnHelper.accessor("zip", {
    //   header: "Zip Code",
    //   size: 50,
    // }),
    // columnHelper.accessor("country", {
    //   header: "Country",
    //   size: 50,
    // }),
    // columnHelper.accessor("stateCode", {
    //   header: "State Code",
    //   size: 50,
    //   Cell: ({ cell }) => (cell.row.original?.stateCode !== "[object Object]" ? cell.row.original?.stateCode : "N/A"),
    // }),
    // columnHelper.accessor("remainingBalance_1_balQuantity", {
    //   header: "Remaining Balance (XAU/INR)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_2_balQuantity", {
    //   header: "Remaining Balance (XAG/INR)",
    //   size: 50,
    // }),
    // columnHelper.accessor("remainingBalance_2_blockedQuantity", {
    //   header: "Blocked Quantity (XAG/INR)",
    //   size: 50,
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.createdAt?.split("T")[0] || "N/A",
    }),

    columnHelper.accessor("invoiceUrl", {
      header: "Invoice",
      size: 30,
      Cell: ({ cell }) => {
        const invoiceUrl = cell.row.original.invoiceUrl;

        const handleViewInvoice = () => {
          if (!invoiceUrl) return;
          window.open(invoiceUrl, "_blank");
        };

        return (
          <Button
            onClick={handleViewInvoice}
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
            }}
          >
            View Invoice
          </Button>
        );
      },
    }),
  ];

  return (
    <>
      {/*  */}
      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"mmtc_buy_response"}
        setFilterData={setFilterData}
      />
      <Box mt={2}>
        {loader ? (
          <Loader1 />
        ) : (
          <CustomTable
            columns={columns}
            data={results}
            loading={loader}
            permissionKey="MMTCBuyResponse"
          />
        )}
      </Box>
    </>
  );
}
